import React, { useEffect, useRef } from 'react';
import { Invoice } from '../data';

type Action = { id: string; label: string; danger?: boolean; divider?: boolean };

const ACTIONS: Action[] = [
  { id: 'mark-paid',      label: 'Mark as paid' },
  { id: 'send-reminder',  label: 'Send reminder' },
  { id: 'record-payment', label: 'Record payment', divider: true },
  { id: 'open-editor',    label: 'Open in editor' },
  { id: 'duplicate',      label: 'Duplicate' },
  { id: 'recurring',      label: 'Convert to recurring', divider: true },
  { id: 'download',       label: 'Download PDF' },
  { id: 'print',          label: 'Print' },
  { id: 'share',          label: 'Share link', divider: true },
  { id: 'archive',        label: 'Archive' },
  { id: 'delete',         label: 'Delete', danger: true },
];

const MENU: React.CSSProperties = {
  position: 'absolute',
  top: 32,
  right: 0,
  minWidth: 220,
  background: '#FFFFFF',
  border: '1px solid #E7EAF0',
  borderRadius: 10,
  boxShadow: '0 10px 30px -8px rgba(14,26,26,.18)',
  padding: 6,
  zIndex: 20,
};

const ITEM: React.CSSProperties = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  padding: '8px 12px',
  fontSize: 13,
  color: '#0E1A1A',
  background: 'transparent',
  border: 0,
  borderRadius: 6,
  cursor: 'pointer',
};

const ITEM_DANGER: React.CSSProperties = { ...ITEM, color: '#B91C1C' };

const DIVIDER: React.CSSProperties = {
  height: 1,
  background: '#F0F2F5',
  margin: '6px 0',
};

type Props = {
  invoice: Invoice;
  onClose: () => void;
  onAction: (action: string, invoice: Invoice) => void;
};

export default function RowChevronMenu({ invoice, onClose, onAction }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div ref={ref} style={MENU} role="menu">
      {ACTIONS.map((a) => (
        <React.Fragment key={a.id}>
          <button
            type="button"
            role="menuitem"
            style={a.danger ? ITEM_DANGER : ITEM}
            onMouseDown={(e) => {
              e.preventDefault();
              onAction(a.id, invoice);
              onClose();
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.background = a.danger ? '#FEF2F2' : '#F7F8FA')
            }
            onMouseOut={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            {a.label}
          </button>
          {a.divider && <div style={DIVIDER} />}
        </React.Fragment>
      ))}
    </div>
  );
}